export const REGION_EVAC_ZONES_REFETCH_INTERVAL = 1000 * 60; // Default refetch interval of 1 minute
